export default __webpack_public_path__ + "static/media/ListQr_icon.f9a314e8.svg";